import {
  FetchRolesCacheKey,
  FetchRolesFilters,
  FetchRolesGqlQuery,
  FetchRolesLimit,
  FetchRolesPage,
  FetchRolesSort
} from '../../rolesTypes';

import { FetchItemCacheKey, FetchItemsGqlQuery } from '../../../../types';

import { useIndexQuery } from '../../../common/reactQuery/hooks/useIndexQuery';

import {
  INITIAL_ROLES_FILTERS,
  INITIAL_ROLES_LIMIT,
  INITIAL_ROLES_PAGE,
  INITIAL_ROLES_SORT
} from '../../rolesConstants';

interface RolesDefaultOptions {
  cacheKey: FetchRolesCacheKey;
  query: FetchRolesGqlQuery;
  initialFilters?: FetchRolesFilters;
  initialSort?: FetchRolesSort;
  initialPage?: FetchRolesPage;
  initialLimit?: FetchRolesLimit;
  options?: {
    cacheTime?: number;
  };
}

interface RolesWithPrefetchItemOptions {
  fetchItemCacheKey: FetchItemCacheKey;
  fetchItemQuery: FetchItemsGqlQuery;
}

interface RolesWithoutPrefetchItemOptions {
  fetchItemCacheKey?: never;
  fetchItemQuery?: never;
}

type RolesOptions = RolesDefaultOptions &
  (RolesWithPrefetchItemOptions | RolesWithoutPrefetchItemOptions);

const scope = 'roles';

function useRoles<ItemType>({
  cacheKey,
  query,
  initialFilters = INITIAL_ROLES_FILTERS,
  initialSort = INITIAL_ROLES_SORT,
  initialPage = INITIAL_ROLES_PAGE,
  initialLimit = INITIAL_ROLES_LIMIT,
  fetchItemCacheKey,
  fetchItemQuery,
  options = {}
}: RolesOptions) {
  const {
    items,
    itemsErrorMessage,
    isFetched,
    isLoading,
    currentPage,
    paginateItems
  } = useIndexQuery<ItemType>({
    scope,
    query,
    cacheKey,
    initialFilters,
    initialLimit,
    initialPage,
    initialSort,
    fetchItemCacheKey,
    fetchItemQuery,
    options
  });

  return {
    rolesPage: currentPage,
    roles: items,
    rolesFetched: isFetched,
    rolesLoading: isLoading,
    rolesErrorMessage: itemsErrorMessage,
    paginateRoles: paginateItems
  };
}

export default useRoles;
